// extracted by mini-css-extract-plugin
export default {"title":"Projects_title__nacP2","twoProjects":"Projects_twoProjects__duChc"};